import React from 'react';
import { Box, Typography, Dialog, IconButton, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import useStyles from './useStyles';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { TEducation } from '../../../../types/User';
import EducationalCard from '../../../../components/Card/EducationalCard';
const useStyle = makeStyles(() => ({
  paper: {
    borderRadius: '1rem',
  },
}));
interface EducationDialogProps {
  educationalBackground: TEducation[];
  closeDialog: () => void;
  fullName: string;
}

const EducationDialog: React.FC<EducationDialogProps> = (props) => {
  const { educationalBackground, closeDialog, fullName = '' } = props;
  const styles = useStyle();
  const classes = useStyles();

  const handleClose = () => closeDialog();

  return (
    <Dialog
      onClose={handleClose}
      open={educationalBackground?.length !== 0}
      maxWidth='xl'
      classes={{ paper: styles.paper }}
    >
      <Box className={classes.mainDialog}>
        <Box className={classes.header}>
          <Typography color='text.main'>{`سابقه ی تحصیلات ${fullName}`}</Typography>
          <IconButton onClick={handleClose}>
            <CloseRoundedIcon color='action' />
          </IconButton>
        </Box>

        <Grid container spacing={2} mt={2}>
          {educationalBackground.map((item: TEducation) => (
            <Grid item lg={4} key={item.id}>
              <EducationalCard education={item} />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Dialog>
  );
};

export default EducationDialog;
